import { render } from "./EventReport.vue?vue&type=template&id=45c34127"
import script from "./EventReport.vue?vue&type=script&lang=js"
export * from "./EventReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__